import { ProjectOverviewFieldsProps } from 'components/ProjectOverview';
import { slugify } from 'src/utils';

type FilterItemsProps = {
  items: ProjectOverviewFieldsProps[];
  city?: string;
  region?: string;
};

export const filterItems = ({ items, city, region }: FilterItemsProps) => {
  let filteredItems = items;

  if (region) {
    filteredItems = filteredItems.filter((item) =>
      item.fields.regions.map((r) => r.id).includes(region)
    );
  }

  if (city) {
    filteredItems = filteredItems.filter(
      (item) => slugify(item.fields.city.value) === slugify(city)
    );
  }

  return filteredItems;
};

export default filterItems;
